import { useSubmitPayment } from './useSubmitPayment';

export const useBuyBundle = ({ item, table, id }) => {
    const submit = useSubmitPayment();
    return {
        buyBundlePremiumHighlight: () =>
            submit({ plan: 'bundle_premium_highlight', table, id, item }),
    };
};
